import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { WrappedApp, WrappedAuthApp, WrappedUXPDevDashboard, WrappedDevUIComponent, WrappedUXPShowcase, WrappedUIComponent, ResponsivePageComponent } from './wrapper-components';
const renderApp = (context) => {
    const container = document.getElementById(context.root);
    if (container) {
        createRoot(container).render(_jsx(WrappedApp, { context: context }));
    }
};
window.renderApp = renderApp;
window.renderDashboard = renderApp;
window.renderAuth = (config) => {
    const container = document.getElementById('root');
    if (!container)
        return;
    createRoot(container).render(_jsx(WrappedAuthApp, { config: config }));
};
window.renderDevDashboard = (context) => {
    const container = document.getElementById(context.root);
    if (container) {
        createRoot(container).render(_jsx(WrappedUXPDevDashboard, { context: context }));
    }
};
window.renderDevUI = (context) => {
    const container = document.getElementById(context.root);
    if (container) {
        createRoot(container).render(_jsx(WrappedDevUIComponent, { context: context }));
    }
};
window.renderShowcase = (root, context) => {
    const container = document.getElementById(root);
    if (container) {
        createRoot(container).render(_jsx(WrappedUXPShowcase, { context: context }));
    }
};
window.renderUI = (context, id, additionalProps) => {
    const container = document.getElementById(context.root);
    if (container) {
        createRoot(container).render(_jsx(WrappedUIComponent, { context: context, id: id, additionalProps: additionalProps }));
    }
};
window.renderPage = (context, widget, embeded) => {
    const container = document.getElementById(context.root);
    if (container) {
        createRoot(container).render(_jsx(ResponsivePageComponent, { context: context, widget: widget, embedded: embeded }));
    }
};
